import { Reveal } from "./Reveal";
import { PROCESS_STEPS } from "../data/content";

export const Process = () => (
  <section className="section section-dark" id="process" data-testid="process-section">
    <div className="wrap">
      <Reveal className="section-head">
        <span className="eyebrow"><span className="sq" /> Our Process</span>
        <h2 data-testid="process-heading">A simple process. Powerful results.</h2>
        <p>We keep it clear, collaborative and focused on getting you the best outcomes.</p>
      </Reveal>
      <Reveal delay={100}>
        <div className="process-rail" data-testid="process-rail">
          {PROCESS_STEPS.map((s) => (
            <div className="process-step" key={s.n} data-testid={`process-step-${s.n}`}>
              <div className="n">{s.n}</div>
              <h4>{s.title}</h4>
              <p>{s.text}</p>
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
